export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://platformaspedytor8-back-production.up.railway.app';
